module.exports = __webpack_public_path__ + "img/Icon1.d3d90b7c.webp";